import { PurchaseProductModel } from './../models/purchaseProductModel';
import { PurchaseOrderModel } from './../models/purchaseOrderModel';
import { BankTranactionModel } from './../models/bankTranactionModel';
import { OrderInfoModel } from './../models/orderInfoModel';
import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BulkProductModel } from '../models/bulkProductModel';
import { map } from 'rxjs/operators';
import { MassPurchaseOrderModel } from '../models/massPurchaseOrderModel';
import { ActiveOldUser } from '../models/activeOldUserModel';
import { NewCodeGeneratedModel } from '../models/newCodeGeneratedModel';
import { ResellerRegisterModel } from '../models/resellerRegisterModel';
import { ProductInfoModel } from '../models/productInfoModel';
import { DiscountModel } from '../models/discountModel';
import { Observable } from 'rxjs';
import { CommonService } from '../../shared/services/common.service';
import { EnumTableModel } from '../../admin/models/enumTableModel';


// URL ---------------------------------------------------------------------------
const GET_BULK_PRODUCT = 'Auth/products/GetBulkProductsForReseller';
const GET_RESELLER_PROFILE = 'Auth/products/GetProduct';
const CREATE_MASS_PURCHASE_ORDER = '/Auth/orders/createOrder';

const GET_MASS_PURCHASE_ORDER = '/Auth/orders/getOrder?orderId=';
const DO_BANK_PAYMENT = 'Auth/payment/dobankpayment';
const VALIDATE_DISCOUNT = 'Auth/Orders/ValidateDiscount';
const GET_DISCOUNT = 'Auth/Orders/GetDiscount';
const CREATE_PURCHASE_ORDER = 'Auth/orders/createOrder';
const GET_PURCHASE_PRODUCT = 'Auth/products/getProduct';
const GET_PRODUCTINFO = 'Auth/products/GetProductInfo';
const ACTIVE_OLD_USER = 'auth/activation/ActivateOldUser';
const REGISTER_RESELLER_INFO = 'Auth/Reseller/ResellerRegister';
const GET_REFERRAL_SOURCE = 'Auth/Orders/GetReferralSources';
@Injectable({
  providedIn: 'root'
})
export class PurchaseService {
  apiEndpoint: string;
  constructor(private http: HttpClient, private commonService: CommonService) {

  }
  getBulkProductsForReseller(productId: number) {
    return this.http.get<BulkProductModel>(
      `${this.commonService.getApiEndpoint()}/${GET_BULK_PRODUCT}/${productId}`
    ).pipe(map(res => res['result'] as BulkProductModel));
  }

  ngOnInit() {
  }

  createMassPurchaseOrder(model: MassPurchaseOrderModel) {
    return this.http.post<any>(
      `${this.commonService.getApiEndpoint()}/${CREATE_MASS_PURCHASE_ORDER}`, model
    ).pipe(map(res => res['result'] as any));
  }




  getMassPurchaseOrder(orderId: string) {
    return this.http.get<OrderInfoModel>(
      `${this.commonService.getApiEndpoint()}/${GET_MASS_PURCHASE_ORDER}${orderId}`
    ).pipe(map(res => res['result'] as OrderInfoModel));
  }

  getPurchaseOrder(orderId: string) {
    return this.http.get<OrderInfoModel>(
      `${this.commonService.getApiEndpoint()}/${GET_MASS_PURCHASE_ORDER}${orderId}`
    ).pipe(map(res => res['result'] as OrderInfoModel));
  }

  doBankPayment(orderId: string, bankName: string) {
    const params = new HttpParams().set('orderId', orderId).set('bankName', bankName);
    return this.http.get<BankTranactionModel>(
      `${this.commonService.getApiEndpoint()}/${DO_BANK_PAYMENT}`, { params: params }
    ).pipe(map(res => res['result'] as BankTranactionModel));
  }

  getDiscount(code: string, productId: number) {
    return this.http.post<number>(
      `${this.commonService.getApiEndpoint()}/${VALIDATE_DISCOUNT}`, { discountCode: code, productId: productId }
    ).pipe(map(res => res['result'] as number));
  }

  getDiscountByCode(code: string): Observable<DiscountModel> {
    return this.http.get<DiscountModel>(
      `${this.commonService.getApiEndpoint()}/${GET_DISCOUNT}?discountCode=${code}`
    ).pipe(map(res => res['result'] as DiscountModel));
  }

  createPurchaseOrder(model: PurchaseOrderModel) {
    return this.http.post<any>(
      `${this.commonService.getApiEndpoint()}/${CREATE_PURCHASE_ORDER}`, model
    ).pipe(map(res => res['result'] as any));
  }

  getPurchaseProducts(productId: number) {
    return this.http.get<PurchaseProductModel[]>(
      `${this.commonService.getApiEndpoint()}/${GET_PURCHASE_PRODUCT}/${productId}`
    ).pipe(map(res => res['result'].prices as PurchaseProductModel[]));
  }

  getProductInfoById(productInfoId: number) {
    return this.http.get<ProductInfoModel>(
      `${this.commonService.getApiEndpoint()}/${GET_PRODUCTINFO}/${productInfoId}`
    ).pipe(map(res => res['result'] as ProductInfoModel));
  }


  getReferralSource(): Observable<EnumTableModel[]> {
    return this.http.get<EnumTableModel[]>(
      `${this.commonService.getApiEndpoint()}/${GET_REFERRAL_SOURCE}`)
      .pipe(map(res => res['result'] as EnumTableModel[]));
  }

  activeOldUser(model: ActiveOldUser) {
    return this.http.post<NewCodeGeneratedModel>(
      `${this.commonService.getApiEndpoint()}/${ACTIVE_OLD_USER}`, model
    ).pipe(map(res => res['result'] as NewCodeGeneratedModel));
  }

  registerResellerInfo(model: ResellerRegisterModel) {
    return this.http.post(
      `${this.commonService.getApiEndpoint()}/${REGISTER_RESELLER_INFO}`, model)
      .pipe(map(res => res['result'] as any));
  }
}
